DatePickerView = require 'views/card/date-picker-view'
Label = require 'models/label'
ModelCacheListener = require 'views/internal/model-cache-listener'
PopOver = require 'views/lib/pop-over'
React = require 'react'
$ = require 'jquery'
t = require('views/internal/recup-with-helpers')('home_up_next')
trackUe = require 'debug/trackUe'
{ CanonicalCard } = require 'views/canonical-card/canonical-card-components'
{ CanonicalDetail } = require 'views/canonical-detail/canonical-detail-components'
{ BoardAndDetailContainer } = require '@atlassian/trello-canonical-components/canonical-card'
{ getOverflowItems, DUE_DATE_TYPE } = require 'views/home/overflow-menu'

class DueDate extends React.Component
  displayName: 'DueDate'

  componentDidMount: ->
    @listenOnCardChange()

  componentDidUpdate: (prevProps) ->
    if prevProps.card != @props.card
      @props.clearModelListeners()
      @listenOnCardChange()

  listenOnCardChange: =>
    @props.modelListener @props.card, 'change', =>
      if !@props.card.getDueDate()
        @props.removeDueDateCard(@props.id)

      @forceUpdate()

  trackOverflowMenuOpens: =>
    { card, org } = @props

    trackUe('home', 'opens', 'overflow menu', '', '', 'by clicking overflow menu icon on due dates card', { cardId: card.id, teamId: org.id })

  onCompleteClick: =>
    { card, org, removeDueDateCard, id, upNextId } = @props

    trackUe('home', 'completes', 'card', '', '', 'by clicking complete button on due dates card', { cardId: card.id, teamId: org.id })
    card.update({ dueComplete: true })

    removeDueDateCard(id)

  onChangeDueDateClick: (event) =>
    { card, org, modelCache } = @props

    trackUe('home', 'changes', 'due date', '', '', 'by clicking change date button on due dates card', { cardId: card.id, teamId: org.id })

    event.preventDefault()

    PopOver.toggle
      view: DatePickerView
      options: { model: card, modelCache }
      elem: $(event.currentTarget)

  trackOnClickCanonicalCard: =>
    { card, org } = @props

    trackUe('home', 'opens', 'card', '' , '', 'by clicking card in due dates feed', { cardId: card.id, teamId: org.id })

  render: t.renderable ->
    { board, card, list, modelCache, org } = @props

    t.tag BoardAndDetailContainer, { width: 420 }, =>
      t.div { onClick: @trackOnClickCanonicalCard }, =>
        t.tag CanonicalCard, {
          board
          boardClassName: 'canonical-stretch'
          canRemove: false
          card
          cardClassName: 'canonical-stretch'
          labels: card.getLabels()?.sort(Label.compare)
          list
          lightBackground: true
          members: card.memberList?.models
          numNotifications: 0
          organization: org
        }

      t.div =>
        t.tag CanonicalDetail, {
          dueSoon: true
          @trackOverflowMenuOpens
          board
          cardId: card.id
          dueDate: card.get('badges')?.due
          onChangeDueDateClick: card.editable() && @onChangeDueDateClick
          onCompleteClick: card.editable() && @onCompleteClick
          overflowMenuItems: getOverflowItems(card, DUE_DATE_TYPE, modelCache, @trackingPrepositionalObject, @trackingIndirectObject)
        }

module.exports = ModelCacheListener(DueDate)



// WEBPACK FOOTER //
// ./app/scripts/views/home/due-date.coffee